export default __webpack_public_path__ + "static/media/HarmoniaUrbanismoBranca.0b17e20b.svg";